import { CONTACT } from "@/data/content";
import { Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";

const socialLinks = [
  {
    icon: Facebook,
    href: "https://www.facebook.com/moneymartindia",
    label: "Facebook",
  },
  {
    icon: Instagram,
    href: "https://www.instagram.com/moneymart_india",
    label: "Instagram",
  },
];

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#0F2D52] text-white pt-16 pb-10 relative overflow-hidden"
    >
      <div className="absolute -top-24 right-0 w-[420px] h-[420px] rounded-full bg-[#1E5AA8]/20 blur-3xl -z-0" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <Link
                to="/"
                className="flex items-center"
                data-testid="page-header-logo"
              >
                <img
                  src="/logo_light.webp"
                  alt="Money Mart"
                  className="h-[80px] w-auto object-contain"
                />
              </Link>
            </div>
            <p className="mt-4 text-sm text-white/70 max-w-md leading-relaxed">
              Advisory-led loan facilitation across secured and unsecured
              products, connecting individuals and businesses with India&rsquo;s
              leading RBI-regulated Banks and NBFCs.
            </p>
            <div className="mt-5 flex items-center gap-3">
              {socialLinks.map(({ icon: Icon, href, label }, i) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${i}`}
                  className="w-9 h-9 rounded-lg bg-white/5 hover:bg-white/10 border border-white/10 flex items-center justify-center mm-transition"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-white/50">
              Company
            </div>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li>
                <a href={`${process.env.REACT_APP_SITE_URL}#why`} className="hover:text-white mm-transition">
                  Why Money Mart
                </a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_SITE_URL}#process`} className="hover:text-white mm-transition">
                  Our Process
                </a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_SITE_URL}#awards`} className="hover:text-white mm-transition">
                  Awards
                </a>
              </li>
              <li>
                <a
                  href={`${process.env.REACT_APP_SITE_URL}#testimonials`}
                  className="hover:text-white mm-transition"
                >
                  Testimonials
                </a>
              </li>
              <li>
                <a href={`${process.env.REACT_APP_SITE_URL}#contact`} className="hover:text-white mm-transition">
                  Contact
                </a>
              </li>
              <li>
                <Link to="/calculators" className="hover:text-white mm-transition">
                  Calculators
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] uppercase tracking-[0.18em] font-bold text-white/50">
              Legal
            </div>
            <ul className="mt-4 space-y-2 text-sm text-white/80">
              <li>
                <Link
                  to="/privacy-policy"
                  className="hover:text-white mm-transition"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="hover:text-white mm-transition"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/disclaimer"
                  className="hover:text-white mm-transition"
                >
                  Disclaimer
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie-policy"
                  className="hover:text-white mm-transition"
                >
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/grievance-redressal"
                  className="hover:text-white mm-transition"
                >
                  Grievance Redressal
                </Link>
              </li>
            </ul>
            <div className="mt-6 text-xs text-white/60">
              <div>GST: {CONTACT.gst}</div>
              <div className="mt-1">{CONTACT.phone}</div>
              <div>{CONTACT.email}</div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <p className="text-xs text-white/60 leading-relaxed max-w-4xl">
            <span className="font-semibold text-white">
              Mandatory Disclaimer:
            </span>{" "}
            Money Mart is a Bank Channel Partner (DSA) and does not provide
            loans directly. All loans are offered and sanctioned solely by
            RBI-regulated Banks and NBFCs subject to their eligibility criteria,
            credit policies and applicable regulations. Interest rates, tenure,
            fees and approval timelines vary depending on the lending
            institution and applicant profile.
          </p>
          <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/50">
            <div>
              © {new Date().getFullYear()} Money Mart. All rights reserved.
            </div>
            <div>
              Made with ❤️ by{" "}
              <a
                href="https://pixalytix.com"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#D4AF37] mm-transition"
              >
                Pixalytix Digital Solutions
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
